module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/warning-9bafb144557186a2970b1985a0c0c939.svg";